import * as FirebaseUI from 'firebaseui';

import {auth, authProviders} from './Firebase';
import {User} from './Firebase.types';

const ui = new FirebaseUI.auth.AuthUI(auth);

export const startUI = () => {
  console.log('UI START');
  ui.start('#firebaseui-auth-container', {
    signInOptions: [...authProviders],
    callbacks: {
      uiShown: function () {
        console.log('UI SHOWN');
      },
      signInFailure(error) {
        console.log('SIGN IN FAILURE', error);
      },
      signInSuccessWithAuthResult: function (result, redirectUrl) {
        console.log('SIGN IN SUCCESS', result);
        return false;
      },
    },
  });
};

export function authListener(
  callback: (user: User | null) => void,
): () => void {
  const subscriber = auth.onIdTokenChanged(user => {
    callback(user);
  });
  return subscriber;
}

export const logout = () => {
  return auth.signOut();
};
